import React from 'react';
import '../App.css';

const ProductCard = (props) => {
  const { icon, title, description, bulletPoints } = props;

  return (
    <div className="product-card">
      <div className="icon-container">
        <img src={icon} alt={title} />
      </div>
      <h2 className="title">{title}</h2>
      <p className="description">{description}</p>
      <ul className="bullet-points">

      </ul>
    </div>
  );
};

export default ProductCard;